var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure IDs")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/integrations/pipelines/details/${_setup.tid}/${_setup.id}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-5 text-right",
            class: {
              "order-1": _setup.direction == 1,
              "order-3": _setup.direction == 2,
            },
          },
          [_c("h5", [_vm._v("Connector")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 order-2 text-center" }, [
          _setup.direction == 1
            ? _c("i", {
                staticClass: "fa fa-arrow-circle-right fa-2x",
                attrs: { title: "From connector to dataset" },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.direction == 2
            ? _c("i", {
                staticClass: "fa fa-arrow-circle-right fa-2x",
                attrs: { title: "From dataset to connector" },
              })
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-5",
            class: {
              "order-1": _setup.direction == 2,
              "order-3": _setup.direction == 1,
            },
          },
          [_c("h5", [_vm._v("Dataset")])]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-5 text-right",
            class: {
              "order-1": _setup.direction == 1,
              "order-3": _setup.direction == 2,
            },
          },
          [
            _vm._l(
              _setup.idPropertyNamesForConnector,
              function (idPropertyNameForConnector, idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "input-group mb-1" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v("ID" + _vm._s(idx + 1)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _setup.idPropertyNamesForConnector[idx],
                          expression: "idPropertyNamesForConnector[idx]",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: {
                        value: _setup.idPropertyNamesForConnector[idx],
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.idPropertyNamesForConnector,
                            idx,
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger btn-sm",
                          on: {
                            click: function ($event) {
                              return _setup.handleRemoveIdPropertyNameForConnector(
                                idx
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa-regular fa-trash-can" })]
                      ),
                    ]),
                  ]
                )
              }
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm",
                on: { click: _setup.handleAddIdPropertyNameForConnector },
              },
              [_vm._v("Add")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click:
                    _setup.invokeChangeIdPropertyNamesForConnectorCommandV1,
                },
              },
              [_vm._v("Save")]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-2 order-2 text-center" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-5",
            class: {
              "order-1": _setup.direction == 2,
              "order-3": _setup.direction == 1,
            },
          },
          [
            _vm._l(
              _setup.idPropertyNamesForDataset,
              function (idPropertyNameForDataset, idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "input-group mb-1" },
                  [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v("ID" + _vm._s(idx + 1)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _setup.idPropertyNamesForDataset[idx],
                          expression: "idPropertyNamesForDataset[idx]",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: {
                        value: _setup.idPropertyNamesForDataset[idx],
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _setup.idPropertyNamesForDataset,
                            idx,
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger btn-sm",
                          on: {
                            click: function ($event) {
                              return _setup.handleRemoveIdPropertyNameForDataset(
                                idx
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa-regular fa-trash-can" })]
                      ),
                    ]),
                  ]
                )
              }
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm",
                on: { click: _setup.handleAddIdPropertyNameForDataset },
              },
              [_vm._v("Add")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { type: "button" },
                on: {
                  click: _setup.invokeChangeIdPropertyNamesForDatasetCommandV1,
                },
              },
              [_vm._v("Save")]
            ),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }